import { ChatInput } from '@/features/adviser-chat/components/ChatInput'
import { WelcomeScreen } from '@/features/adviser-chat/components/WelcomeScreen'
import type { HavenLaunchAction } from '@/features/adviser-chat/lib/types'
import type { SendMessage } from '@/features/adviser-chat/components/messages/ThreadView'

interface FullScreenHomeProps {
  firstName?: string
  onSend: SendMessage
  inputDisabled: boolean
  onLaunchAction: (action: HavenLaunchAction) => void
}

export const FullScreenHome = ({
  firstName,
  onSend,
  inputDisabled,
  onLaunchAction,
}: FullScreenHomeProps) => (
  <WelcomeScreen
    firstName={firstName}
    input={<ChatInput onSend={onSend} disabled={inputDisabled} initialFocus />}
    illustrationClassName="[@media(max-height:600px)]:hidden"
    onSuggestionClick={onSend}
    onLaunchAction={onLaunchAction}
  />
)
